module.exports = __webpack_public_path__ + "img/logo2.9f9b735f.svg";